import MultiSelectPricesFilter, {
  mapLocalSelectionToGA4Result,
} from '@/scopes/prices/components/Filters/MultiSelectPricesFilter'
import { PricesUseCasesContext } from '@/scopes/prices/components/PricesUseCasesContext'
import {
  participantsSelector,
  roomTypeFilterOptionsSelector,
} from '@/scopes/prices/components/selectors'
import { createPricesFilterClickEvent } from '@/scopes/prices/domain/analytics'
import { FiltersInPricesValues, Option } from '@/scopes/prices/domain/filters/types'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import * as React from 'react'
import { useIntl } from '../../../../intl'

export function RoomTypeFilter() {
  const intl = useIntl()
  const { selectFilter } = React.useContext(PricesUseCasesContext)
  const { selectedValues: Participants } = usePricesSelector(participantsSelector)

  const { options, selectedValues } = usePricesSelector(roomTypeFilterOptionsSelector)
  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'RoomType', selection })

  if (Participants && Participants?.length > 1) {
    return null
  }

  return (
    <MultiSelectPricesFilter
      options={options}
      selectedValues={selectedValues}
      setSelection={setSelection}
      label={intl.formatMessage({ id: 'prices_filters_roomtype_label' })}
      placeholder={intl.formatMessage({ id: 'prices_filters_roomtype_placeholder' })}
      confirmButton={intl.formatMessage({ id: 'prices_filters_roomtype_confirm_button' })}
      icon="IconBed"
      analyticsEventBuilder={(selection: string | string[] | undefined, options: Option[]) => {
        return createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'roomType',
          result: mapLocalSelectionToGA4Result(selection, options),
        })
      }}
    />
  )
}
